import Collapse from "@material-ui/core/Collapse";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  AttendanceDevice,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../Assets/Images/aaa.png";
import Mobile from "../../../../../Assets/Images/Mobile.svg";
import SelectList from "../../../../../Component/SelectList/SelectList";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
  menuItem: {
    "&:focus": {
      backgroundColor: "#2ecaff29",
      "& $primary, & $icon": {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
});

class MobileDevice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isdraft: false,
      ismobiledevice: true,
      isgpsrestricted: false,
      isautopunch: false,
      ispunchoutofradius: false,
      LatLongiList: [],
      selectedOptions: [],
      ErList: false,
      allowedmobiledevicegps: [],
      helperText: "",
      isbidirection: false,
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("attendancedevicepolicy");
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    this.props.StepError(5, false);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);

    this.props.onRef({
      onNext: this.OnNext,
    });
    const text = this.props.Language.attendancedevicepolicy.HtMobile;
    this.props.setHelperText({ helperText: text });
    this.GetLatLongi();
    const attendanceDeviceInfo = this.props.attendanceDeviceReducer;
    if (!this.isEmpty(attendanceDeviceInfo)) {
      const { isbidirection } = attendanceDeviceInfo;
      const isdraft = attendanceDeviceInfo.isdraft != false;
      let allowedmobiledevicegps = [];
      let ismobiledevice = true;
      let isgpsrestricted = false;
      let isautopunch = false;
      let ispunchoutofradius = false;
      if (isbidirection == true) {
        allowedmobiledevicegps = [];
        ismobiledevice = false;
        isgpsrestricted = false;
        isautopunch = false;
        ispunchoutofradius = false;
      } else {
        allowedmobiledevicegps = attendanceDeviceInfo.allowedmobiledevicegps
          ? attendanceDeviceInfo.allowedmobiledevicegps
          : [];
        ismobiledevice = attendanceDeviceInfo.ismobiledevice != false;
        isgpsrestricted = attendanceDeviceInfo.isgpsrestricted == true;
        isautopunch = false;
        ispunchoutofradius = false;
        if (allowedmobiledevicegps.length > 0) {
          // allowedmobiledevicegpsid = allowedmobiledevicegps[0].allowedmobiledevicegpsid ? allowedmobiledevicegps[0].allowedmobiledevicegpsid : 0
          isautopunch = allowedmobiledevicegps[0].isautopunch
            ? allowedmobiledevicegps[0].isautopunch
            : false;
          ispunchoutofradius = false;
        }
      }
      this.setState(
        {
          ismobiledevice,
          isgpsrestricted,
          allowedmobiledevicegps,
          ispunchoutofradius,
          isautopunch,
          isdraft,
          isbidirection,
        },
        () => {
          this.UpdateAttendanceDeviceReducer();
        },
      );
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  GetLatLongi() {
    instance
      .get("/attendance/alllatlong")
      .then((result) => {
        let LatLongiList = [];
        result.data.result.length > 0
          ? (LatLongiList = result.data.result)
          : (LatLongiList = []);
        this.setState({ LatLongiList });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  UpdateIsmobiledevice(name, HtField, selectedItem) {
    this.HelperSliderFlag([HtField]);
    if (selectedItem.displayvalue == false) {
      this.setState({
        isgpsrestricted: false,
        selectedOptions: [],
        isautopunch: false,
        ispunchoutofradius: false,
        ErList: false,
        allowedmobiledevicegps: [],
      });
    }
    this.setState({ [name]: selectedItem.displayvalue }, () => {
      this.UpdateAttendanceDeviceReducer();
    });
  }

  UpdateSelectedValue(name, HtField, selectedItem) {
    this.HelperSliderFlag([HtField]);
    this.setState({ [name]: selectedItem.displayvalue }, () => {
      this.Updateallowedmobiledevicegps();
    });
  }

  SetTrue() {
    this.HelperSliderFlag("HtEnforceGPSlocationBasedAttendance");
    const isgpsrestricted = !this.state.isgpsrestricted;
    if (isgpsrestricted == false) {
      this.props.StepError(5, false);
      this.setState(
        {
          selectedOptions: [],
          isautopunch: false,
          ispunchoutofradius: false,
          ErList: false,
          allowedmobiledevicegps: [],
        },
        () => {
          this.UpdateAttendanceDeviceReducer();
        },
      );
    }
    this.setState({ isgpsrestricted }, () => {
      this.Validate();
      this.UpdateAttendanceDeviceReducer();
    });
  }

  SetFalse() {
    this.HelperSliderFlag("HtEnforceGPSlocationBasedAttendance");
    this.props.StepError(5, false);
    this.setState(
      {
        isgpsrestricted: false,
        selectedOptions: [],
        isautopunch: false,
        ispunchoutofradius: false,
        ErList: false,
        allowedmobiledevicegps: [],
      },
      () => {
        this.UpdateAttendanceDeviceReducer();
      },
    );
  }

  HandleMultiSelect = (selectedOption) => {
    // this.HelperSliderFlag([HtField])
    const index = this.state.allowedmobiledevicegps.findIndex(
      (item) => item.officeaddressid == selectedOption.officeaddressid,
    );
    const { allowedmobiledevicegps } = this.state;
    if (index == -1) {
      selectedOption.allowedmobiledevicegpsid &&
        (selectedOption.allowedmobiledevicegpsid = 0);
      allowedmobiledevicegps.push(selectedOption);
    } else {
      allowedmobiledevicegps.splice(index, 1);
    }
    this.setState({ allowedmobiledevicegps }, () => {
      this.Validate();
      this.Updateallowedmobiledevicegps();
    });
  };

  Updateallowedmobiledevicegps() {
    const { allowedmobiledevicegps } = this.state;
    if (allowedmobiledevicegps.length > 0) {
      allowedmobiledevicegps.forEach((option) => {
        option.allowedmobiledevicegpsid = this.state.allowedmobiledevicegpsid;
        option.isautopunch = this.state.isautopunch;
        option.ispunchoutofradius = false;
      });
    }
    this.setState({ allowedmobiledevicegps }, () => {
      this.UpdateAttendanceDeviceReducer();
    });
  }

  UpdateAttendanceDeviceReducer = () => {
    const attendanceDeviceInfo = this.props.attendanceDeviceReducer;
    attendanceDeviceInfo.ismobiledevice = this.state.ismobiledevice;
    attendanceDeviceInfo.isgpsrestricted = this.state.isgpsrestricted;
    attendanceDeviceInfo.allowedmobiledevicegps =
      this.state.allowedmobiledevicegps;
    // attendanceDeviceInfo.isautopunch = this.state.isautopunch
    if (
      attendanceDeviceInfo.allowedmobiledevicegps &&
      attendanceDeviceInfo.allowedmobiledevicegps[0]
    ) {
      attendanceDeviceInfo.allowedmobiledevicegps[0].ispunchoutofradius = false;
    }
    this.props.AttendanceDevice({ ...attendanceDeviceInfo });
  };

  Validate = () => {
    let isValid;
    if (
      this.state.isgpsrestricted == true &&
      this.state.allowedmobiledevicegps.length == 0
    ) {
      this.setState({ ErList: true });
      this.props.StepError(5, true);
      isValid = false;
    } else {
      this.setState({ ErList: false });
      this.props.StepError(5, false);
      isValid = true;
    }
    return isValid;
  };

  OnNext = () => {
    if (this.Validate()) {
      this.UpdateAttendanceDeviceReducer();
      this.props.click();
    }
  };

  HelperSliderFlag(HtField) {
    // this.setState({ HelperSlider: flag })
    const text = get(this.props, `Language.attendancedevicepolicy[${HtField}]`);
    // let text = this.props.Language.attendancedevicepolicy[HtField]
    this.props.setHelperText({ helperText: text, open: true });
  }

  render() {
    const { classes } = this.props;
    const { allowedmobiledevicegps } = this.state;

    let selectedIDObj = [];
    const options = [
      {
        displayvalue: true,
        displayname: <FormattedMessage id="LbYes" defaultMessage="Yes" />,
      },
      {
        displayvalue: false,
        displayname: <FormattedMessage id="LbNo" defaultMessage="No" />,
      },
    ];
    return (
      <div className={classes.root}>
        <div className="stepper-scroller padding-top-0">
          <div className="stepper-scroller-content">
            <div className="inner-wrapper">
              {this.state.isbidirection == true ? (
                <div className="innew-wrapper opaque">
                  <p className="depedent-select-list-head">
                    <FormattedMessage
                      id="LbMobileDevicesCantRegister"
                      defaultMessage="Mobile devices can't register 'in & out' direction of an employee. You have used directional biometric devices, we recommend you to review your biometric set-up."
                    />
                  </p>
                </div>
              ) : (
                <div className="innew-wrapper opaque">
                  <div>
                    <p className="depedent-select-list-head">
                      <FormattedMessage
                        id="LbEnableMobileBasedAttendance1"
                        defaultMessage="Would you like to enable mobile based attendance (via Andriod/iOS-app)"
                      />
                    </p>
                    <div className="device-form-img">
                      <img src={Mobile} align="left" height="100" />
                    </div>
                    <div>
                      <SelectList
                        data={options}
                        Selected={this.state.ismobiledevice}
                        onSelected={this.UpdateIsmobiledevice.bind(
                          this,
                          "ismobiledevice",
                          "HtIsMobileDevice",
                        )}
                      />
                    </div>
                  </div>
                  {this.state.ismobiledevice == true ? (
                    <div className="margin-top-10">
                      <p className="depedent-select-list-head">
                        <FormattedMessage
                          id="LbEnforceGPSlocationBasedAttendance"
                          defaultMessage="Would you like to enforce GPS location based attendance"
                        />
                      </p>
                      <div
                        className={
                          this.state.isgpsrestricted == true
                            ? "depedent-select-list select-list-item"
                            : "depedent-select-list"
                        }
                        onClick={this.SetTrue.bind(this)}
                      >
                        <span>
                          <FormattedMessage id="LbYes" defaultMessage="Yes" />
                        </span>
                        {this.state.isgpsrestricted == true ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected"></span>
                        )}
                      </div>
                      {this.state.isgpsrestricted == true ? (
                        <div className="bottom-border"></div>
                      ) : (
                        ""
                      )}
                      <div className="inner-level-div iplist-attendence">
                        <Collapse
                          in={this.state.isgpsrestricted}
                          timeout="auto"
                          unmountOnExit
                          className="overflow-initial first-level-padding"
                        >
                          <MenuList className="">
                            <p className="depedent-select-list-head">
                              <FormattedMessage
                                id="LbSelectGPS"
                                defaultMessage="Select GPS"
                              />
                            </p>
                            <div className="bottom-border"></div>
                            {this.state.LatLongiList.map((item) => {
                              if (allowedmobiledevicegps.length > 0) {
                                selectedIDObj = allowedmobiledevicegps.filter(
                                  (x) =>
                                    x.officeaddressid == item.officeaddressid,
                                );
                              }

                              return (
                                <MenuItem
                                  key={item.key}
                                  onClick={this.HandleMultiSelect.bind(
                                    this,
                                    item,
                                    "HtSelectGPS",
                                  )}
                                  className={
                                    selectedIDObj.length > 0 &&
                                    selectedIDObj[0].officeaddressid
                                      ? "select-list-item bottom-border inner-level-div-second-level"
                                      : "bottom-border inner-level-div-second-level"
                                  }
                                >
                                  <ListItemText
                                    className="no-padding"
                                    primary={item.locationname}
                                    secondary={
                                      <React.Fragment>
                                        {`Latitude ${item.latitude} Longitude ${item.longitude}`}{" "}
                                      </React.Fragment>
                                    }
                                  />

                                  {selectedIDObj.length > 0 &&
                                  selectedIDObj[0].officeaddressid ? (
                                    <span
                                      onClick={() =>
                                        this.HandleMultiSelect.bind(
                                          this,
                                          item,
                                          "HtSelectGPS",
                                        )
                                      }
                                      className="floatright selected-box"
                                    >
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                      >
                                        <path d="M0 0h24v24H0z" fill="none" />
                                        <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                      </svg>
                                    </span>
                                  ) : (
                                    <span
                                      onClick={() =>
                                        this.HandleMultiSelect.bind(
                                          this,
                                          item,
                                          "HtSelectGPS",
                                        )
                                      }
                                      className="not-selected-box"
                                    ></span>
                                  )}
                                </MenuItem>
                              );
                            })}
                          </MenuList>
                        </Collapse>
                        <div>
                          {this.state.ErList == true ? (
                            <span
                              className="caption-error display-block"
                              style={{ padding: "0 30px 10px 30px" }}
                            >
                              <FormattedMessage
                                id="ErSelectGPS"
                                defaultMessage="Please select GPS"
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div
                        className={
                          this.state.isgpsrestricted == false
                            ? "depedent-select-list select-list-item"
                            : "depedent-select-list"
                        }
                        onClick={this.SetFalse.bind(this)}
                      >
                        <span>
                          <FormattedMessage id="LbNo" defaultMessage="No" />
                        </span>
                        {this.state.isgpsrestricted == false ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected"></span>
                        )}
                      </div>
                      {this.state.isgpsrestricted == true ? (
                        <div>
                          {/* <div className="innew-wrapper opaque">
                            <p className="depedent-select-list-head">
                              <FormattedMessage
                                id="LbAutomaticallyMarkEmployee’sAttendance "
                                defaultMessage="Would you like to automatically mark the employee’s attendance based on their mobile device’s GPS location?"
                              />
                            </p>
                            <div>
                              <SelectList
                                data={options}
                                Selected={this.state.isautopunch}
                                onSelected={this.UpdateSelectedValue.bind(
                                  this,
                                  "isautopunch",
                                  "HtIsAutoPunch",
                                )}
                              />
                            </div>
                          </div> */}
                          {/* <div className="innew-wrapper opaque">
                            <p className="depedent-select-list-head margin-top-10">
                              <FormattedMessage
                                id="LbAutomaticallySendRequest"
                                defaultMessage="Would you like to automatically send a request for approval in case the Clock-in/out is attempted from outside the location radius?"
                              />
                            </p>
                            <div>
                              <SelectList
                                data={options}
                                Selected={this.state.ispunchoutofradius}
                                onSelected={this.UpdateSelectedValue.bind(
                                  this,
                                  "ispunchoutofradius",
                                  "HtIsPunchoutofRadius",
                                )}
                              />
                            </div>
                          </div> */}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}

              {/* <div className="padding-top-30">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    onClick={this.OnNext.bind(this)}
                                >
                                    <FormattedMessage id="BtNext" defaultMessage="Next" />
                                </Button>
                            </div> */}
              {/* <div className="draftbutton-wrapper">
                                    <div className="draftclosebutton cursour-pointer" onClick={this.OnCancel.bind(this)}>X <span className="draftclosebutton-text"><FormattedMessage id="BtClose" defaultMessage="Close" /></span></div>

                                    <div className="draftbutton-innerwrapper">
                                        {this.state.isdraft == true ?
                                        <span className="draftbutton cursour-pointer" onClick={this.OnSave.bind(this, 'SaveAsDraft')}>
                                            <Done />
                                            <span className="draft-option"><FormattedMessage id="BtSaveAsDraft" defaultMessage="Save As Draft" /></span>
                                        </span>
                                        :
                                        <span className="draftbutton cursour-pointer" onClick={this.OnSave.bind(this, 'Save')}>
                                            <DoneAllIcon />
                                            <span className="draft-option"><FormattedMessage id="BtSave" defaultMessage="Save" /></span>
                                        </span>
                                        }
                                    </div>
                                </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MobileDevice.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  attendanceDeviceReducer: state.attendanceDeviceReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      AttendanceDevice: (data) => AttendanceDevice(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(MobileDevice)));
